<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SiteFooter',
    mounted() { },
    methods: {
        onDataLoaded(data) {
            this.menuData = data.data;
            this.isLoading = false;
        },
    },
    computed: {
        ...mapGetters({
            menuData: 'getFooterNav',
            isLoading: 'getFooterNavIsLoading',
        }),
    }
};
</script>

<template>
    <footer class="site-footer">
        <div class="site-footer__main">
            <p class="site-footer__claim">{{ $t('siteFooter.claim') }}</p>
            <ul class="site-footer__nav" v-if="!isLoading">
                <li class="site-footer__nav-item" v-for="(item, i) in menuData" v-bind:key="i">
                    <router-link 
                        v-bind:to="'/' + item.slug" 
                        class="site-footer__nav-item__link" 
                        v-html="item.title">
                    </router-link>

                </li>
            </ul>
        </div>

        <div class="site-footer__imprint">
            <div class="site-footer__imprint__owner">
                <h4 class="site-footer__imprint__owner__title">{{ $t('siteFooter.ownerTitle') }}</h4>
                <a href="https://www.guido-fluri-stiftung.ch/" target="_blank" class="site-footer__imprint__owner__link">
                    <img src="../assets/images/logo-gf-stiftung-compact.svg" alt="Logo Guido Fluri Stiftung">
                </a>
            </div>
            <div class="site-footer__imprint__supporter">
                <h4 class="site-footer__imprint__supporter__title">{{ $t('siteFooter.supporterTitle') }}</h4>
                <ul class="site-footer__imprint__supporter__logos">
                    <li class="site-footer__imprint__supporter__logo">
                        <a href="https://www.angehoerige.ch/" target="_blank" class="site-footer__imprint__supporter__link">
                            <img src="../assets/images/logo-nap.svg" alt="Logo Netzwerk Angehörigenarbeit Psychiatrie">
                        </a>
                    </li>
                    <li class="site-footer__imprint__supporter__logo">
                        <a href="https://www.promentesana.ch/" target="_blank" class="site-footer__imprint__supporter__link">
                            <img src="../assets/images/logo-promentesana.svg" alt="Logo pro mente sana">
                        </a>
                    </li>
                    <li class="site-footer__imprint__supporter__logo">
                        <a href="https://www.selbsthilfeschweiz.ch/" target="_blank" class="site-footer__imprint__supporter__link">
                            <img src="../assets/images/logo-selbst-hilfe-schweiz.svg" alt="Logo Selbsthilfe Schweiz">
                        </a>
                    </li>
                    <li class="site-footer__imprint__supporter__logo">
                        <a href="https://stand-by-you.ch/" target="_blank" class="site-footer__imprint__supporter__link">
                            <img src="../assets/images/logo-stand-by-you.svg" alt="Logo Stand by You Schweiz">
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </footer>
</template>

<style lang="scss" scoped>
.site-footer {
    box-sizing: border-box;
    padding: 3rem 5rem;
    margin-top: 12rem;
    background: $color-primary;
    color: $color-light;
    overflow: hidden;

    @include breakpoint("sm-down") {
        padding: 2.2rem 3rem;
    }

    @include breakpoint("xs-down") {
        padding: 1rem 2rem;
    }
}
.site-footer__main {
    display: flex;
    justify-content: space-between;
    padding: 1.9rem 0;

    @include breakpoint("xs-down") {
        display: block;
    }
}
.site-footer__claim {
    display: block;
    flex: 1;
    max-width: 34rem;
    margin: 0;
    font-size: 2.4rem;
    letter-spacing: 0.081rem;
    line-height: 1.2;

    @include breakpoint("md-down") {
        font-size: 2.16rem;
    }
}
.site-footer__nav {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    padding: 0;
    margin: 0.16rem 0;

    @include breakpoint("sm-down") {
        display: none
    }
}
.site-footer__nav-item {
    display: block;

    @include breakpoint("xs-down") {
        margin: 0.4rem 0;
    }
}
.site-footer__nav-item:not(:last-child):after {
    content: "•";
    margin: 0 1rem;
}
.site-footer__nav-item__link {
    display: inline-block;
    color: $color-light;
    text-decoration: none;
    font-size: 1.5rem;
    letter-spacing: 0.107rem;
    text-transform: uppercase;
}

.site-footer__imprint {
    display: block;
    margin-top: 9.6rem;
}
.site-footer__imprint__owner {
    max-width: 32rem;
    min-width: 28.8rem;
    margin-bottom: 2.4rem;
}
.site-footer__imprint__owner__title,
.site-footer__imprint__supporter__title {
    margin: 0 0 1rem;
    font-size: 1.6rem;
    font-weight: 300;
    color: rgba($color-light, .57);
}
.site-footer__imprint__supporter__logos {
    display: flex;
    margin: 0 -1.2rem;
    padding: 0;

    @include breakpoint("xs-down") {
        flex-wrap: wrap;
    }
}
.site-footer__imprint__supporter__logo {
    display: block;
    margin: 0 1.2rem;
}
.site-footer__imprint__owner__link,
.site-footer__imprint__supporter__link {
    opacity: .33;
}
</style>
